import type { PropsWithChildren } from 'react';

import { VFlex, cn } from '@/package';

const ContainerOverview = ({ children }: PropsWithChildren) => {
  return (
    <VFlex className="relative z-10 w-full" justify="center">
      <div
        className={cn(
          'w-[calc(100vw-var(--spacing-sidebar))] min-w-[calc(var(--container-md)-var(--spacing-sidebar))]',
          '@xl:w-[calc(120rem-var(--spacing-sidebar))]',
          'px-8',
        )}
      >
        {children}
      </div>
    </VFlex>
  );
};

export default ContainerOverview;
